import { VyFormSection, VyIcon } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { VySwitchField } from '../../../../../../design-system-adapters/forms';
import { PaymentTermSelect } from '../../modify-panel-shared/selectors';
import { FieldGrid } from '../../modify-panel-shared/layout';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export type PaymentSectionProps = {
  showSeparateInvoice?: boolean;
  showPaymentTerm?: boolean;
};

export function PaymentSection({ showSeparateInvoice = true, showPaymentTerm = true }: PaymentSectionProps) {
  const { itemIndex: productIndex } = useChargeContext();
  const separatePath =
    `fixedProducts.${productIndex}.variants.0.pricing.priceConfiguration.shouldCreateSeparateInvoice` as const;

  return (
    <VyFormSection icon={<VyIcon icon="SectionPayment" width={20} height={20} />} title="Payment">
      <FieldGrid>
        {showSeparateInvoice && (
          <VySwitchField<PlanInputForm>
            name={separatePath}
            title="Issue as separate invoice"
            description="Send this item in its own invoice instead of bundling it with others."
            data-field-span="full"
            data-vy="plan-charge-drawer-separate-invoice-switch"
          />
        )}
        {showPaymentTerm && <PaymentTermSelect productIndex={productIndex} productType="fixedProducts" />}
      </FieldGrid>
    </VyFormSection>
  );
}
